export default __webpack_public_path__ + "37846c1d8c6745f28affcb2a4e413f14.png";